/** Point d’entrée : monte l’application dans `#racine` (cf. `index.html`). */

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './App'
import { estHoteMarketingConnu } from './lib/hoteMarketing'
import { preparerPageVitrine } from './router'
import { brancherRenouvellement } from './lib/renouvellement'
import './index.css'

const racine = document.getElementById('racine')
brancherRenouvellement()
if (racine === null) {
  throw new Error('Élément #racine introuvable dans index.html.')
}

const conteneurApp = racine

function monterApp() {
  createRoot(conteneurApp).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

// La racine marketing porte déjà un véritable premier écran HTML. Le conserver
// jusqu'au chargement du module vitrine évite : texte brut → spinner → vitrine.
// Si le module échoue, l'écran statique et ses liens restent utilisables.
if (location.pathname === '/' && estHoteMarketingConnu(location.hostname)) {
  try {
    await preparerPageVitrine()
    monterApp()
  } catch {
    // Le contenu statique est le repli ; aucun écran blanc à afficher ici.
  }
} else {
  monterApp()
}
